/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { FormGroup, Button, Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  SR_RECORD_TO_RECORD_DISPERSION_MODEL,
  SR_MODELING_DISPERSION,
  RESIDUAL_DRIFT_SIMULATION_METHOD,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import {
  Field,
  FormGroup as ModelFormGroup,
} from '#components/pages/Models/Model/support/form/index.js';
import StructuralResponsesTable from './Table/index.js';

type Props = {|
  fieldsByName: Object,
  form: string,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const StructuralResponseTableView = (props: Props): Element<'div'> => {
  const { fieldsByName, form, heading, onBack, onNext } = props;
  return (
    <Container>
      <Row>
        <Col>
          <h2>{heading}</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="float-right">
            <Button id="addResponse" className="pr-0" to="add" color="link" tag={Link}>
              + Add Response
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <StructuralResponsesTable form={form} />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col>
          <FormGroup tag="fieldset">
            <legend>Structural Response Dispersion Modeling</legend>
            <ModelFormGroup form={form} fields={[SR_RECORD_TO_RECORD_DISPERSION_MODEL]}>
              <Row>
                <Col lg="6">
                  <Field field={fieldsByName[SR_RECORD_TO_RECORD_DISPERSION_MODEL]} />
                </Col>
              </Row>
            </ModelFormGroup>
            <ModelFormGroup form={form} fields={[SR_MODELING_DISPERSION]}>
              <Row>
                <Col lg="6">
                  <Field field={fieldsByName[SR_MODELING_DISPERSION]} />
                </Col>
              </Row>
            </ModelFormGroup>
            <ModelFormGroup form={form} fields={[RESIDUAL_DRIFT_SIMULATION_METHOD]}>
              <Row>
                <Col lg="6">
                  <Field field={fieldsByName[RESIDUAL_DRIFT_SIMULATION_METHOD]} />
                </Col>
              </Row>
            </ModelFormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="pt-3">
            <BackButton onClick={onBack} />
            <NextButton onClick={onNext} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StructuralResponseTableView;
